import { render, staticRenderFns } from "./Custo.vue?vue&type=template&id=742ee49b"
import script from "./Custo.vue?vue&type=script&lang=js"
export * from "./Custo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports